/**
 * History Panel
 *
 * Displays the complete chat history for the current player session.
 * Allows perusing all past conversations in chronological order.
 */

import { Box, Typography, Card, CardContent, Divider } from "@mui/material";
import { useChatContext } from "../../contexts/ChatContext";
import { MessageBubble } from "../chat/MessageBubble";

export function HistoryPanel() {
  const { messages } = useChatContext();

  return (
    <Card
      className="panel"
      sx={{
        backgroundColor: "background.paper",
        border: 1,
        borderColor: "divider",
      }}
    >
      <CardContent className="panel-header" sx={{ p: 1.5, pb: 1 }}>
        <Typography
          variant="overline"
          sx={{
            color: "primary.main",
            fontWeight: 700,
            letterSpacing: 1,
            fontSize: "0.65rem",
            display: "block",
            mb: 0.5,
          }}
        >
          History
        </Typography>
        <Typography variant="caption" color="text.secondary" display="block">
          {messages.length} message{messages.length !== 1 ? "s" : ""} in current session
        </Typography>
      </CardContent>

      <Box className="panel-scroll">
        {messages.length === 0 ? (
          <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", py: 8 }}>
            <Typography variant="body2" color="text.secondary" align="center">
              No chat history yet.
              <br />
              Start a conversation to see messages here.
            </Typography>
          </Box>
        ) : (
          <Box sx={{ p: 1.5 }}>
            {messages.map((message, index) => (
              <Box key={message.id}>
                <MessageBubble message={message} playAudio={false} />
                {index < messages.length - 1 && (
                  <Divider sx={{ my: 2, opacity: 0.3 }} />
                )}
              </Box>
            ))}
          </Box>
        )}
      </Box>
    </Card>
  );
}
